module.exports = __webpack_public_path__ + "static/media/jquery.6a38d7ce.svg";